"use client"

const COOLDOWN_MS = 300

let lastFireworkTime = 0

interface Heart {
  el: HTMLDivElement
  startX: number
  startY: number
  endX: number
  endY: number
  duration: number
  rotate: number
  startTime: number
}

export function spawnEmojiFirework(
  originX: number,
  originY: number,
  emoji: string,
): boolean {
  const now = Date.now()
  if (now - lastFireworkTime < COOLDOWN_MS) return false
  lastFireworkTime = now

  const color = emoji === "❤️" ? "#f74c6c" : "#d97706"
  const count = Math.floor(Math.random() * 4) + 6
  const hearts: Heart[] = []

  for (let i = 0; i < count; i++) {
    const el = document.createElement("div")
    el.style.cssText =
      "position:fixed;z-index:99999;pointer-events:none;font-size:12px;line-height:1;user-select:none;"
    el.style.color = color
    el.textContent = emoji === "❤️" ? "❤" : "★"
    document.body.appendChild(el)

    // 360° uniform spread
    const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4
    const distance = 16 + Math.random() * 24
    const endX = originX + Math.cos(angle) * distance
    const endY = originY + Math.sin(angle) * distance
    const duration = 400 + Math.random() * 200
    const rotate = (Math.random() - 0.5) * 20

    el.style.left = `${originX}px`
    el.style.top = `${originY}px`
    el.style.opacity = "1"
    el.style.transform = "scale(0) translate(-50%, -50%)"

    hearts.push({
      el,
      startX: originX,
      startY: originY,
      endX,
      endY,
      duration,
      rotate,
      startTime: 0,
    })
  }

  const startTime = performance.now()
  for (const h of hearts) h.startTime = startTime

  function frame(time: number) {
    let alive = false

    for (const h of hearts) {
      const progress = (time - h.startTime) / h.duration
      if (progress >= 1) {
        h.el.remove()
        continue
      }
      alive = true

      // Cubic ease-out
      const ease = 1 - Math.pow(1 - progress, 3)
      const currX = h.startX + (h.endX - h.startX) * ease
      const currY = h.startY + (h.endY - h.startY) * ease

      // Scale: grow then shrink (Telegram style)
      const scale = progress < 0.3 ? progress / 0.3 * 1.2 : 1.2 - (progress - 0.3) * 1.6
      const opacity = 1 - progress
      const rot = h.rotate * progress

      h.el.style.left = `${currX}px`
      h.el.style.top = `${currY}px`
      h.el.style.opacity = `${opacity}`
      h.el.style.transform = `scale(${Math.max(scale, 0)}) rotate(${rot}deg) translate(-50%, -50%)`
    }

    if (alive) {
      requestAnimationFrame(frame)
    }
  }

  requestAnimationFrame(frame)
  return true
}
